// custom hook: useIsIntegrated.jsx

import { useQuery } from "@tanstack/react-query";
import { integrationKeys } from "../queryKeys";
import useAPI from "./useAPI";

const useIsIntegrated = (name) => {
  const { fetchIntegrations } = useAPI();

  const integrationsQuery = useQuery({
    queryKey: integrationKeys.all,
    queryFn: () => fetchIntegrations(), // Call without params to get all integrations
  });

  // Check if specific integration exists when name is provided
  const isIntegrated = name
    ? (integrationsQuery.data || []).includes(name)
    : null;

  return {
    isIntegrated,
    integrations: integrationsQuery.data || [],
    isIntegratedLoading: integrationsQuery.isLoading,
    isIntegratedSuccess: integrationsQuery.isSuccess,
  };
};

export default useIsIntegrated;
